// This is a simple button component that takes an onClick function and a text prop.
// Example usage:
// <Button onClick={() => console.log("Hello")} text="Click me" />
//
// Example output:
// <button>Click me</button>
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledButton = styled.button`
  background: #fff;
  backface-visibility: hidden;
  border-radius: .375rem;
  border-style: solid;
  border-width: .125rem;
  box-sizing: border-box;
  color: #212121;
  cursor: pointer;
  display: inline-block;
  font-size: .75rem;
  font-weight: 700;
  font-family: player2;
  letter-spacing: -.01em;
  line-height: 1.3;
  padding: .875rem 1.125rem;
  position: relative;
  text-align: left;
  text-decoration: none;
  transform: translateZ(0) scale(1);
  transition: transform .2s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;


  &:not(:disabled):hover {
   transform: scale(1.05);
  }

  &:not(:disabled):hover:active {
    transform: scale(1.05) translateY(.125rem);
  }

  &:focus {
    outline: 0 solid transparent;
  }

  &:focus:before {
    content: "";
    left: calc(-1*.375rem);
    pointer-events: none;
    position: absolute;
    top: calc(-1*.375rem);
    transition: border-radius;
    user-select: none;
  }

  &:focus:not(:focus-visible) {
    outline: 0 solid transparent;
  }

  &:focus:not(:focus-visible):before {
    border-width: 0;
  }

  &:not(:disabled):active {
    transform: translateY(.125rem);
  }

  @media (max-width: 480px) {
    font-size: .5rem;
    padding: .5rem .75rem;
  }
`
interface ButtonProps {
  onClick: () => void
  text: string
}

const Button = ({ onClick, text }: ButtonProps): JSX.Element => {
  return (
    <StyledButton onClick={onClick}>{text}</StyledButton>
  )
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}

export default Button
